import get from 'lodash/get';

// creates encoded URI from base URL and object with params
// and returns its length
const getExpectedEncodedUriLength = (baseUrl, params) => {
    const getURIParameter = (encodedUrl, key, index) => {
        const value = get(params, key);
        if (typeof value === 'object' && value) {
            return Object.keys(value).reduce(
                (u, k) => getURIParameter(u, `${key}[${k}]`, index),
                encodedUrl
            );
        }
        const separator = index === 0 ? '?' : '&';
        encodedUrl += `${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        return encodedUrl;
    };

    return Object.keys(params).reduce(getURIParameter, baseUrl).length;
};

export {getExpectedEncodedUriLength};
